module.exports = __webpack_public_path__ + "static/media/nav-logo.ac915359.png";